import $api from 'http'

export async function getSurveyData(data) {
  return $api.get(`/surveys/`, data)
}
export async function getSurveyUser(id, data) {
  return $api.get(`/startsurveys/${id}/`, data)
}
export async function getSurveyAllUser(id, formData) {
  return $api.patch(`/startsurveysall/${id}/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}

export async function GetURLSurvey(id) {
  return $api.post(`/geturltsurvey/${id}/`)
}
export async function StartSurveyUser(id) {
  return $api.post(`/startsurveys/${id}/`, {}, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function StartSurveyAllUser(id, formdata) {
  return $api.post(`/startsurveysall/${id}/`, formdata,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}

export async function StartSurveyAllAnonUser(id, formdata) {
  return $api.post(`/startsurveysallanon/${id}/`, formdata,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}

export async function getSurveyUserData(data) {
  return $api.get(`/surveysuser/`, data)
}


export async function getSurveyUserAllDetailData(id, data) {
  return $api.get(`/surveysalluser/${id}/`, data)
}
export async function getSurveyUserAll(data) {
  return $api.get(`/surveysuserall/`, data)
}
export async function PostSurvey(formdata) {
  return $api.post(`/surveys/`, formdata ,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}

export async function getSurveyDetailData(id, data) {
  return $api.get(`/survey/${id}/`, data)
}

export async function getSurveyUserDetailData(id, data) {
  return $api.get(`/surveysuser/${id}/`, data)
}


export async function OnOffSurveyDetailData(id,) {
  return $api.post(`/surveyonoff/${id}/`, {}, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function OnOffSurveyDetailAnonimData(id,) {
  return $api.post(`/surveyanonymous/${id}/`, {}, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function updateSurveyDetailData(id, formdata) {
  return $api.patch(`/survey/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function PostPartSurveySurvey(id, formdata) {
  return $api.post(`/surveydetail/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function PatchPartSurveySurveyDefendant(id, formdata) {
  return $api.post(`/surveydetaildefendant/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
export async function removeDefendant(id,) {
  return $api.post(`/removedefendant/${id}/`, {}, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function moveDefendantUp(id,) {
  return $api.post(`/movedefendantup/${id}/`, {}, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function moveDefendantDown(id,) {
  return $api.post(`/movedefendantdown/${id}/`, {}, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}


export async function ChangeDefendant(id,  formdata) {
  return $api.post(`/changedefendant/${id}/`,  formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}

export async function ChangeDefendantAll(id,  formdata) {
  return $api.post(`/changedefendantall/${id}/`,  formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}
export async function updatePointsPart(id,  formdata) {
  return $api.post(`/changeuserpart/${id}/`,  formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}